'use strict';
var testPaymentUiController = /** @class */ (function () {
    /*@ngInject*/
    function testPaymentUiController($log, $scope, $timeout, $state, $q, $sce, $rootScope, CreditCardService, Util, CartService, AddressService, $filter, SettingsService, Auth, $window, FocusOnService, configurationService) {
        var self = this;
        self.Auth = Auth;
        self.bearerToken = "";
        self.paymentURL = "";
        self.$sce = $sce;
        self.$state = $state;
        self.uiRouterState = this.$state.current.name;
        self.iframe = "";
        self.CartService = CartService;
        self._$rootScope = $rootScope;
        self.$window = $window;
        this.environment = configurationService.getEnvironmentConfiguration();
        this.getToken();
    }
    testPaymentUiController.prototype.getToken = function () {
        var _this = this;
        this.Auth.getUserEmail().then(function (email) {
            _this.userEmail = email;
        });
        this.Auth.getToken().then(function (data) {
            _this.bearerToken = data;
            _this.creditCardListURL = _this.$sce.trustAsResourceUrl(_this.environment.cardManagerAppUrl);
            _this.paymentURL = _this.$sce.trustAsResourceUrl(_this.environment.cardManagerAppUrl);
        });
    };
    testPaymentUiController.prototype.creditCardIframeloaded = function () {
        var _this = this;
        console.log('creditCardIframeloaded- start execution');
        var iframe = document.getElementById("creditCardListFrameElement").contentWindow;
        this.Auth.getToken().then(function (data) {
            var bearerToken = data;
            _this.Auth.getUserEmail().then(function (email) {
                console.log('creditCardIframeloaded- get token and Email done');
                var sendData = {
                    token: bearerToken,
                    emailId: email,
                    page: 'manage-cards'
                };
                _this.message('token', sendData, iframe);
                console.log('creditCardIframeloaded- Send message to credit card iFrame. sendData-', sendData);
            });
        });
    };
    testPaymentUiController.prototype.checkoutIframeloaded = function () {
        var _this = this;
        console.log('checkoutIframeloaded- start execution');
        var iframe = document.getElementById("paymentframeelement").contentWindow;
        this.Auth.getToken().then(function (data) {
            var bearerToken = data;
            _this.Auth.getUserEmail().then(function (email) {
                console.log('checkoutIframeloaded- get token and Email done');
                var sendData = {
                    token: bearerToken,
                    emailId: email,
                    page: 'checkout-payment',
                    shippingAddress: _this.CartService.cartData ? _this.CartService.cartData.shippingAddress : ''
                };
                _this.message('token', sendData, iframe);
                console.log('checkoutIframeloaded- Send message to checkout iFrame. sendData-', sendData);
            });
        });
    };
    testPaymentUiController.prototype.message = function (eventType, request, iFrameObj) {
        iFrameObj.postMessage({
            eventtype: eventType,
            data: request,
            type: 'Emerson'
        }, '*');
    };
    return testPaymentUiController;
}());
export default testPaymentUiController;
//# sourceMappingURL=test-payment-ui.controller.js.map